var render = function () {
  var _vm$rules$_vm$COMPANY;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    mode: _vm.mode,
    items: _vm.items
  }, false), [_c('template', {
    slot: "사업자등록증"
  }, [_vm.mode == 'form' ? [_c('v-file-input', {
    attrs: {
      "outlined": "",
      "dense": "",
      "prepend-icon": null,
      "prepend-inner-icon": "mdi-file-upload-outline",
      "rules": (_vm$rules$_vm$COMPANY = _vm.rules[_vm.COMPANY.value]) === null || _vm$rules$_vm$COMPANY === void 0 ? void 0 : _vm$rules$_vm$COMPANY.businessRegistration
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.businessRegistration,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "businessRegistration", $$v);
      },
      expression: "form.businessRegistration"
    }
  })] : _vm._e(), _vm.mode == 'view' ? [_c('image-popup', {
    attrs: {
      "src": _vm.businessRegistration,
      "size": 100
    }
  })] : _vm._e()], 2), _c('template', {
    slot: "주소"
  }, [_vm.mode == 'form' ? [_c('v-address-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'primary',
        width: 100,
        height: 50,
        className: 'mt-n8'
      }
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })] : _vm._e(), _vm.mode == 'view' ? [_vm._v(" " + _vm._s(_vm.address) + " ")] : _vm._e()], 2), _c('template', {
    slot: "기업로고"
  }, [_vm.mode == 'form' ? [_c('small', {
    staticClass: "grey--text"
  }, [_vm._v("권장사이즈 : 230*68(px)")]), _c('v-file-input', {
    attrs: {
      "outlined": "",
      "dense": "",
      "prepend-icon": null,
      "prepend-inner-icon": "mdi-file-upload-outline"
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "logo", $$v);
      },
      expression: "form.logo"
    }
  })] : _vm._e(), _vm.mode == 'view' ? [_c('image-popup', {
    attrs: {
      "src": _vm.logo,
      "size": 100
    }
  })] : _vm._e()], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }